import { ComponentRoute } from '@/classes'

const QuickItemRoutes = {
  QuickItemListView: new ComponentRoute('/quickitems', 'QuickItemListView'),
  QuickItemView: new ComponentRoute('/quickitems/:itemQuickId', 'QuickItemView'),
  QuickItemDetail: new ComponentRoute('/quickitems/:itemQuickId', 'QuickItemDetail')
}

export default QuickItemRoutes
